import { render, staticRenderFns } from "./SearchCustomers.vue?vue&type=template&id=1bfd10c6&scoped=true&"
import script from "./SearchCustomers.vue?vue&type=script&lang=js&"
export * from "./SearchCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd10c6",
  null
  
)

export default component.exports